import React from 'react'
import { IMarquee } from './types'
import GatsbyLink from '../Link'
import MarqueeContainer from 'react-fast-marquee'

export const Marquee = ({ slides, enable }: { slides: IMarquee[]; enable: string }) => {
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <div className="absolute left-0 w-full bg-gray-accent-light py-4">
            <MarqueeContainer autoFill pauseOnHover>
                {slides.map(({ text, url }, index) => {
                    const Container = url ? GatsbyLink : 'div'
                    return (
                        <Container {...(url ? { to: url } : null)} key={text + index} className="mx-2">
                            "{text}"
                        </Container>
                    )
                })}
            </MarqueeContainer>
        </div>
    )
}
export default Marquee
